<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter', filterUiState('woodenPanel', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionWoodenPanel',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Holzwerkstoff&shy;platte',
      items: [
        { title: '≥ 22 mm', value: 22 },
        { title: '≥ 25 mm', value: 25 },
        { title: 'ohne', value: null }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('woodenPanel', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'woodenPanel',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
